import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	csvFieldMappingHeading: {
		id: 'project-create-importer-upload-flow.mapping-screen.csv-field-mapping-heading',
		defaultMessage: 'Map project fields',
		description: 'Map Fields as part of the import project flow heading',
	},
	validationErrorFlagTitle: {
		id: 'project-create-importer-upload-flow.mapping-screen.validation-error-flag-title',
		defaultMessage: 'Something went wrong',
		description: 'Message to be shown as flag description when import validation fails',
	},
	validationErrorFlagMessage: {
		id: 'project-create-importer-upload-flow.mapping-screen.validation-error-flag-message',
		defaultMessage: 'Check your connection, then give it another try.',
		description: 'Error message when validation fails',
	},
	summaryRequiredTitle: {
		id: 'project-create-importer-upload-flow.mapping-screen.summary-required-title',
		defaultMessage: 'Summary is a required field in Jira',
		description: 'Section message description for summary required in mapping',
	},
	summaryRequiredMessage: {
		id: 'project-create-importer-upload-flow.mapping-screen.summary-required-message',
		defaultMessage:
			'Make sure to map the summary field to the appropriate CSV column to proceed with the import.',
		description: 'Section message description for summary required in mapping',
	},
	postValidationBannerHeading: {
		id: 'project-create-importer-upload-flow.mapping-screen.post-validation-banner-heading',
		defaultMessage: 'All good to proceed',
		description: 'Post validation banner heading',
	},
	postValidationBannerDescription: {
		id: 'project-create-importer-upload-flow.mapping-screen.post-validation-banner-description',
		defaultMessage: 'Please click on next to validate fields and proceed to the next step',
		description: 'Section message description for summary required in mapping',
	},
	networkErrorHeading: {
		id: 'project-create-importer-upload-flow.mapping-screen.network-error-heading',
		defaultMessage: 'We couldn’t load this page',
		description: 'Network error heading',
	},
	networkErrorDescription: {
		id: 'project-create-importer-upload-flow.mapping-screen.network-error-description',
		defaultMessage:
			'Try refreshing the page or wait for a few minutes before importing the project again.',
		description: 'Network error description',
	},
});
